import { Edit, NoteAddOutlined, Warning } from '@material-ui/icons';
import DeleteIcon from '@material-ui/icons/DeleteForeverOutlined';
import InfoIcon from '@material-ui/icons/HelpOutline';
import LockIcon from '@material-ui/icons/LockOpen';
import { Form } from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Field, change, reduxForm, submit } from 'redux-form';
import { BLUE, ORANGE, PERMISSIONS, PERMISSION_ENTITIES, RED } from '../../_config/consts';
import { elaborateForbiddenDaysString, hasFormWritePermission, localizeHelpCenterLink } from '../../_config/utils';
import AbilityProvider from '../../permissionsUtils/AbilityProvider';
import * as UtilsActions from '../../redux/actions/utils.actions';
import AccessProfilesIconCustom from '../CustomIcons/AccessProfilesIconCustom.jsx';
import SelectableRowField from './Fields/SelectableRows/SelectableRowField.jsx';
import CalendarClockIconCustom from '../CustomIcons/CalendarClockIconCustom.jsx';
import KeyOutlinedIconCustom from '../CustomIcons/KeyOutlinedIconCustom.jsx';
import UserOutlineIconCustom from '../CustomIcons/UserOutlineIconCustom.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import CredentialTimeSelector from './Elements/CredentialTimeSelector.jsx';
import FormFlatContainer from './Elements/FormFlatContainer.jsx';
import LocksSelectorField from './Elements/LocksSelectorField.jsx';
import TagsSelectorListField from './Elements/TagsSelectorListField.jsx';
import CustomField from './Fields/CustomField.jsx';
import MDSwitchField from './Fields/MDSwitch/MDSwitchField.jsx';
import GuestNoEmailForm from './GuestNoEmailForm.jsx';
import StandardDeviceValidationForm from './StandardDeviceValidationForm/StandardDeviceValidationForm.jsx';
import InfoSection from '../InfoSection/InfoSection.jsx';



const validate = (values) => {
  const errors = {};
  if (values) {
    if (!values.deviceId) {
      errors.deviceId = 'required';
    } else if (values.deviceId && !((/^[0-9A-F]{8}$/i.test(values.deviceId)) || (/^[0-9A-F]{14}$/i.test(values.deviceId)))) {
      errors.deviceId = 'genericCardNumberInvalid';
    }

    if (!values.guestTags || (values.guestTags && _.isEmpty(values.guestTags))) {
      errors.guestTags = 'required';
    }

    if (!values.lockTags || (values.lockTags && _.isEmpty(values.lockTags))) {
      errors.lockTags = 'required';
    }


    if (!values.credentialTimeframe
        || !values.credentialTimeframe.startDate
        || !values.credentialTimeframe.endDate) {
      errors.credentialTimeframe = 'reservationDateIntevalErrorMessage';
    }
    
    if (values.credentialTimeframe && values.credentialTimeframe.endDate && moment(values.credentialTimeframe.endDate).isAfter('2099-12-31')) {
      errors.credentialTimeframe = 'errorEndDateTooBig';
    }
    
    if (!values.timeIntervalFrom) {
      errors.timeIntervalFrom = 'required';
    }

    if (!values.timeIntervalTo) {
      errors.timeIntervalTo = 'required';
    }
    if (values.timeIntervalTo && values.timeIntervalFrom) {
      const toTime = moment(values.timeIntervalTo);
      const fromTime = moment(values.timeIntervalFrom);
      const toDate = moment(0).hour(toTime.hour()).minute(toTime.minute()).second(0);
      const fromDate = moment(0).hour(fromTime.hour()).minute(fromTime.minute()).second(0);
      if (toDate.isSameOrBefore(fromDate)) {
        errors.timeIntervalTo = 'Interval not valid';
      }
    }
  }

  return errors;
};

const CUSTOM_PROFILE_OPTION = {
  id: -1,
  customOptionElement: (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: -5 }}>
      <Edit style={{ color: '#3f3f3f', marginRight: 10, fontSize: 22 }} />
      <h4 style={{ color: '#3f3f3f', fontWeight: 'bold' }}><Entity entity="customProfile" /></h4>
    </div>
  ),
};

@reduxForm({ form: 'HyperKeyCredentialsForm', validate })
@connect(state => ({ form: state.form.HyperKeyCredentialsForm }))
class HyperKeyCredentialsForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showGuestNoEmailForm: false,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(change('HyperKeyCredentialsForm', 'type', 'F9000'));
  }

  componentDidUpdate(prevProps) {
    const { form, guestsFilteredByTags, accessProfilesData, onSelectAccessProfile, dispatch } = this.props;
    const prevGuest = prevProps.guestsFilteredByTags && prevProps.guestsFilteredByTags.data && prevProps.guestsFilteredByTags.data[0];
    const currentGuest = guestsFilteredByTags && guestsFilteredByTags.data && guestsFilteredByTags.data[0];
    const prevAccessProfileId = prevGuest ? prevGuest.accessProfileId : null;
    const currentAccessProfileId = currentGuest ? currentGuest.accessProfileId : null;
    const currentSelection = form && form.values && form.values.accessProfileSelection;
    const isEditing = form && form.values && form.values.deviceBackendId;
    if (isEditing) return;
    const availableProfile = currentAccessProfileId && accessProfilesData ? _.find(accessProfilesData, { id: currentAccessProfileId }) : null;
    if (
      currentAccessProfileId
      && currentAccessProfileId !== prevAccessProfileId
      && availableProfile
      && currentSelection !== currentAccessProfileId
      && onSelectAccessProfile
    ) {
      dispatch(change('HyperKeyCredentialsForm', 'accessProfileSelection', currentAccessProfileId));
      onSelectAccessProfile(currentAccessProfileId);
    } else if (!currentAccessProfileId && prevAccessProfileId && currentSelection) {
      dispatch(change('HyperKeyCredentialsForm', 'accessProfileSelection', null));
    }
  }

  onToggleShowGuestNoEmailForm(value) {
    this.setState({ showGuestNoEmailForm: value });
  }

  onOpenValidationInfo() {
    const helpURL = localizeHelpCenterLink('f9000-keys-validation-period');
    window.open(helpURL);
  }

  render() {
    const {
      form,
      availableLockTags,
      availableUserTags,
      onGuestTagsChange,
      onLockTagsChange,
      guestsFilteredByTags,
      locksFilteredByTags,
      onLockFilterModeChange,
      onGuestInputChange,
      onLockInputChange,
      onFetchMoreGuests,
      onFetchMoreLocks,
      onDeleteCard,
      onSaveKeyNotes,
      dispatch,
      onCreateAnonymousUserForF9000,
      onSelectAccessProfile,
      accessProfilesData,
    } = this.props;
    const { showGuestNoEmailForm } = this.state;
    const notes = form && form.values && form.values.notes ? form.values.notes : '';
    const isEditing = form && form.values && form.values.deviceBackendId;
    const canDeleteStandardDevices = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.DELETE], PERMISSION_ENTITIES.STANDARD_DEVICE);
    const canReadUser = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.USER);
    const canReadLock = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.SMART_LOCK);
    const dateFrom = form && form.values && form.values.credentialTimeframe && form.values.credentialTimeframe.startDate;
    const guestTags = form && form.values && form.values.guestTags;
    const dateTo = form && form.values && form.values.credentialTimeframe && form.values.credentialTimeframe.endDate;
    const timeFrom = form && form.values && form.values.timeIntervalFrom;
    const timeTo = form && form.values && form.values.timeIntervalTo;
    const daysString = form && form.values && form.values.daysOfTheWeek && elaborateForbiddenDaysString(form.values.daysOfTheWeek) ? elaborateForbiddenDaysString(form.values.daysOfTheWeek) : '';
    const smartLocksSelected = form && form.values && form.values.selectedLocksTags;
    const locksHaveError = smartLocksSelected && smartLocksSelected.data ? _.find(smartLocksSelected.data, smartLock => smartLock.model !== 'F9000') : false;
    const hideGuestNoEmailSwitch = isEditing || !_.isEmpty(guestTags);
    const isAccessProfilesActive = dispatch(UtilsActions.isAccessProfileAddonActive());
    const selectedGuestAccessProfileId = guestsFilteredByTags && guestsFilteredByTags.data && guestsFilteredByTags.data[0] ? guestsFilteredByTags.data[0].accessProfileId : null;
    const selectedGuestAccessProfile = selectedGuestAccessProfileId ? _.find(accessProfilesData, { id: selectedGuestAccessProfileId }) : null;
    const isUsingAccessProfile = form && form.values && form.values.accessProfileSelection && form.values.accessProfileSelection === selectedGuestAccessProfileId;
    const canEditCredentialRule = hasFormWritePermission(PERMISSION_ENTITIES.STANDARD_DEVICE, isEditing) && !isUsingAccessProfile;
    const accessProfileOptions = selectedGuestAccessProfile ? [
      {
        id: selectedGuestAccessProfile.id,
        customOptionElement: (
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: -5 }}>
            <AccessProfilesIconCustom style={{ color: '#3f3f3f', marginRight: 10, width: 22 }} />
            <h4 style={{ color: '#3f3f3f', fontWeight: 'bold' }}>{selectedGuestAccessProfile.name}</h4>
          </div>
        ),
      },
      CUSTOM_PROFILE_OPTION,
    ] : [];
    return (
      <Form>
        <FormFlatContainer
          title="insertHyperKeyIdTitle"
          containerStyle={{ marginRight: 10, marginTop: 5 }}
          icon={<KeyOutlinedIconCustom style={{ width: 22 }} />}
        >
          <Entity
            componentClass={Field}
            name="deviceId"
            componentAttribute="placeholder"
            entity="insertHyperKeyNumber"
            component={CustomField}
            helpText={<Entity entity="insertHyperKeyIdTitleHelpText" />}
            textFormattingFunction={value => value.replace(/\s+/g, '')}
            type="text"
            disabled={isEditing}
          />
        </FormFlatContainer>
        <FormFlatContainer
          title="cardDescription"
          subtitle="cardDescriptionSubtitle"
          containerStyle={{ marginRight: 10 }}
          icon={<NoteAddOutlined style={{ fontSize: 22 }} />}
        >
          <Entity
            componentClass={Field}
            name="notes"
            componentAttribute="placeholder"
            entity="insertCardDescription"
            component={CustomField}
            type="textarea"
            disabled={!hasFormWritePermission(PERMISSION_ENTITIES.STANDARD_DEVICE, isEditing)}
            className="form-control-custom"
          />
          {isEditing && hasFormWritePermission(PERMISSION_ENTITIES.STANDARD_DEVICE, isEditing) && (
            <MDButton
              title={<Entity entity="saveNotes" />}
              backgroundColor={BLUE}
              onClick={() => onSaveKeyNotes(notes)}
            />
          )}
        </FormFlatContainer>
        <FormFlatContainer
          title="cardTagGuestTitle"
          subtitle="cardTagGuestSubtitle"
          containerStyle={{ marginRight: 10 }}
          icon={<UserOutlineIconCustom style={{ width: 22 }} />}
        >
          <TagsSelectorListField
            name="guestTags"
            formName="HyperKeyCredentialsForm"
            selectedTagsFieldName="selectedGuestTags"
            tags={availableUserTags}
            selectedTags={guestsFilteredByTags}
            form={form}
            tagsType="GUEST"
            title="guestTagsCard"
            placeholder="insertGuestTagsForCard"
            listTitle="selectedUsers"
            emptyTagSelectionText={canReadUser ? 'noUsersForSelectedTag' : null}
            onFetchMoreItems={page => onFetchMoreGuests(page)}
            onTagsChange={values => onGuestTagsChange(values)}
            onInputChange={value => onGuestInputChange(value)}
            isSingleChoice
            disabled={!hasFormWritePermission(PERMISSION_ENTITIES.STANDARD_DEVICE, isEditing)}
          />
          {hideGuestNoEmailSwitch ? null : (
            <Field
              name="withoutEmail"
              label={<Entity entity="createNewUserForF9000" />}
              titleStyle={{ fontSize: 16, color: '#3f3f3f', fontWeight: 'bold' }}
              containerstyle={{ marginTop: 10 }}
              component={MDSwitchField}
              activeText="createNewUserForCardWarning"
              activeTextIcon={<Warning style={{ color: ORANGE, marginRight: 10, marginTop: 0, fontSize: 20 }} />}
              onHandleChange={value => this.onToggleShowGuestNoEmailForm(value)}
            />
          )}
          {showGuestNoEmailForm && !hideGuestNoEmailSwitch ? (
            <div>
              <GuestNoEmailForm
                onSubmit={(guestData) => onCreateAnonymousUserForF9000(guestData)}
              />
              <MDButton
                title={<Entity entity="createUser" />}
                backgroundColor={BLUE}
                disabled={!hasFormWritePermission(PERMISSION_ENTITIES.USER, isEditing)}
                onClick={() => dispatch(submit('GuestNoEmailForm'))}
              />
            </div>
          ) : null}
        </FormFlatContainer>
        {selectedGuestAccessProfile && isAccessProfilesActive ? (
          <FormFlatContainer
            title="defaultTimeProfileTitle"
            subtitle="defaultTimeProfileSubtitle"
            containerStyle={{ marginRight: 10 }}
            icon={<CalendarClockIconCustom style={{ width: 22 }} />}
          >
            <h4 style={{ color: '#3f3f3f', fontWeight: 'bold', marginBottom: 0, marginTop: 20 }}>{<Entity entity="selectAccessProfileOrCustom" />}</h4>
            <Field
              name="accessProfileSelection"
              component={SelectableRowField}
              onHandleChange={value => onSelectAccessProfile(value)}
              isSingleChoice
              rowStyle={{ maxHeight: 55, maxWidth: '80%' }}
              options={{
                content: accessProfileOptions,
              }}
              listContainerStyle={{ marginTop: 0 }}
              listStyle={{ marginTop: 0 }}
            />
          </FormFlatContainer>
        ) : null}
        <FormFlatContainer
          title="hyperKeyLockTitle"
          subtitle="hyperKeyTagLockSubtitle"
          icon={<LockIcon style={{ fontSize: 22 }} />}
          containerStyle={{ marginRight: 10 }}
        >
          <LocksSelectorField
            name="lockTags"
            formName="HyperKeyCredentialsForm"
            selectedTagsFieldName="selectedLocksTags"
            tags={availableLockTags}
            selectedTags={locksFilteredByTags && locksFilteredByTags[0]}
            form={form}
            tagsType="LOCK"
            placeholder="insertLockTagsForCredential"
            listTitle="selectedLocks"
            emptyTagSelectionText={canReadLock ? 'noLocksSelectedWithTag' : null}
            title="cylinderTags"
            lockHasErrorCondition={lock => lock.model !== 'F9000'}
            onFetchMoreItems={page => onFetchMoreLocks(page)}
            onTagsChange={values => onLockTagsChange(values)}
            onInputChange={value => onLockInputChange(value)}
            onFilterModeChange={values => onLockFilterModeChange(values)}
            disabled={!canEditCredentialRule}
          />
          {locksHaveError ? (
            <InfoSection
              title="selectedLocksIncompatibleError"
              gravity="error"
              titleStyle={{ fontWeight: 'normal' }}
            />
          ) : null}
        </FormFlatContainer>
        <FormFlatContainer
          title="credentialTimeAndDate"
          icon={<CalendarClockIconCustom style={{ width: 22 }} />}
          containerStyle={{ marginRight: 10 }}
        >
          <CredentialTimeSelector
            formName="HyperKeyCredentialsForm"
            canEdit={canEditCredentialRule}
          />
          {dateFrom && dateTo ? (
            <div style={{ paddingTop: 10, borderTop: '2px solid #157495', marginLeft: 15, display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
              <InfoIcon style={{ color: '#3f3f3f', marginRight: 12, fontSize: 20 }} />
              <h5 style={{ fontSize: 15, lineHeight: '1.5em', color: '#3f3f3f' }}>
                <Entity
                  entity="hyperKeyVerbalDescription"
                  key={`${dateFrom}-${dateTo}-${timeFrom}-${timeTo}`}
                  data={{
                    dateFrom: moment(dateFrom).format('LL'),
                    dateTo: moment(dateTo).format('LL'),
                    timeFrom: moment(timeFrom).format('LT'),
                    timeTo: moment(timeTo).format('LT'),
                  }}
                />
                {!daysString ? '' : <span style={{ marginLeft: 5 }}><Entity entity="except" />{daysString}</span>}
              </h5>
            </div>
          ) : null}
        </FormFlatContainer>
        {!isEditing && !isUsingAccessProfile ? (
          <StandardDeviceValidationForm
            form={form}
            formName="HyperKeyCredentialsForm"
            onInfo={() => this.onOpenValidationInfo()}
          />
        ) : null}
        {hasFormWritePermission(PERMISSION_ENTITIES.STANDARD_DEVICE, isEditing) && (
          <div style={{ backgroundColor: 'white', position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}>
            <MDButton
              title={<Entity entity="save" />}
              containerStyle={{ position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}
              style={{ height: 45, borderRadius: 0 }}
              disabled={locksHaveError}
              onClick={() => dispatch(submit('HyperKeyCredentialsForm'))}
            />
          </div>
        )
        }
        {onDeleteCard && canDeleteStandardDevices && (
          <FormFlatContainer
            title="deleteCredential"
            subtitle="deleteCredentialCardWarning"
            containerStyle={{ marginRight: 10 }}
            icon={<DeleteIcon style={{ fontSize: 24 }} />}
          >
            <MDButton
              title={<Entity entity="deleteHyperKey" />}
              backgroundColor={RED}
              onClick={() => onDeleteCard()}
            />
          </FormFlatContainer>
        )}
      </Form>
    );
  }
} 

export default HyperKeyCredentialsForm;
